import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UpdateCurrentYetai } from '../../store/features/yetai';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
  </Box>
);

export default function YetaiPiece(props) {
  const dispatch = useDispatch();
  const clickHandler = () => {
    if (props.data.url && props.data.url !== '') {
      window.open(props.data.url, '_blank');
      return;
    }
    dispatch(UpdateCurrentYetai(props.data));
  }
  const storageURL = process.env.REACT_APP_Stroage_URL;

  const cardContent = (
    <>
      <CardContent sx={{ padding: 0, }}>
        <img src={storageURL + props.data.thumb} loading="lazy"></img>
      </CardContent>
      <CardActions sx={{ display: 'flex', flexWrap: 'wrap', margin: 0 }}>
        <Stack spacing={1} direction="row" sx={{ width: '100%' }}>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            {props.data.name}
          </Typography>
        </Stack>
        <Stack spacing={1} direction="row" justifyContent="flex-start" style={{ marginLeft: 0 }}>
          <Rating size="small" name="half-rating-read" value={Number((5 * props.data.score / 100).toFixed(1))} precision={0.1} readOnly />
          <Typography sx={{ fontSize: 14 }} color="text.secondary">
            {(5 * props.data.score / 100).toFixed(1)}
          </Typography>
        </Stack>
        {
          props.data.distance && <Stack spacing={1} direction="row" justifyContent="flex-start" style={{ marginLeft: 0,width:'100%' }}>
            <Typography sx={{ fontSize: 12,color:'#999' }} color="text.secondary">
              {(props.data.distance).toFixed(1) + '公里'}
            </Typography>
          </Stack>
        }
      </CardActions>
    </>
  );

  return (
    props.data && <Card sx={{ minWidth: 75, boxShadow: "none",height:'auto !important',minHeight:'auto !important' }} style={{}} onClick={clickHandler}>
      {(!props.data.url || props.data.url === '') ? (
        <Link to="/yetaidetail">
          {cardContent}
        </Link>
      ) : (
        cardContent
      )}
    </Card>
  );
}